// Shared so every product that hosts the `ErrorContainer` derives the same keys.
// A rename here breaks the build in every product instead of silently dropping a CSS class.
export const errorContainerClassKeys = ['errorContainer', 'errorAlert', 'errorMessage'];
export const errorContainerSlots = {
  errorContainer: ['errorContainer'],
  errorAlert: ['errorAlert'],
  errorMessage: ['errorMessage']
};